import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

/* Original name @uswitch/trustyle.frozen-input */
import { Fragment, useEffect, useState } from 'react';
import { useThemeUI } from 'theme-ui';
import { TruEdit } from '@uswitch/spark-icons/tru';
import { jsx as _jsx } from "theme-ui/jsx-runtime";
import { jsxs as _jsxs } from "theme-ui/jsx-runtime";
var UswitchNavy = '#141424';
var editIconWidth = 69;
export var FrozenInput = function FrozenInput(_ref) {
  var _theme$elements$input, _theme$elements$input2, _theme$elements$input3;

  var text = _ref.text,
      freezable = _ref.freezable,
      inputRef = _ref.inputRef,
      children = _ref.children;

  var _useState = useState(freezable && !!text),
      _useState2 = _slicedToArray(_useState, 2),
      frozen = _useState2[0],
      setFrozen = _useState2[1];

  var _useThemeUI = useThemeUI(),
      theme = _useThemeUI.theme;

  var iconColor = theme && theme.colors[(_theme$elements$input = theme.elements.input) === null || _theme$elements$input === void 0 ? void 0 : (_theme$elements$input2 = _theme$elements$input.frozen) === null || _theme$elements$input2 === void 0 ? void 0 : (_theme$elements$input3 = _theme$elements$input2.button) === null || _theme$elements$input3 === void 0 ? void 0 : _theme$elements$input3.color] || UswitchNavy;
  useEffect(function () {
    if (freezable && !frozen && !!text && inputRef && inputRef.current) {
      inputRef.current.focus();
    }
  }, [frozen]);

  if (!frozen) {
    return _jsx(Fragment, {
      children: children
    });
  }

  return _jsxs(Fragment, {
    children: [_jsxs("div", {
      sx: {
        fontSize: 'xs',
        fontWeight: 'base',
        lineHeight: '1.29',
        alignItems: 'center',
        backgroundColor: 'frozen-bg',
        display: 'flex',
        height: '64px',
        justifyContent: 'space-between',
        variant: 'elements.input.frozen.base'
      },
      children: [_jsx("p", {
        sx: {
          color: 'text',
          overflow: 'hidden',
          padding: '0 24px',
          textOverflow: 'ellipsis',
          width: "calc(100% - ".concat(editIconWidth, "px)"),
          variant: 'elements.input.frozen.text',
          m: 0
        },
        children: text
      }), _jsx("button", {
        "aria-label": "Edit Value",
        sx: {
          variant: 'elements.input.frozen.button'
        },
        onClick: function onClick() {
          return setFrozen(false);
        },
        children: _jsx(TruEdit, {
          color: iconColor
        })
      })]
    }), _jsx("div", {
      sx: {
        variant: 'elements.input.frozen.hidden'
      },
      children: children
    })]
  });
};
//# sourceMappingURL=index.js.map